import parse, { domToReact } from 'html-react-parser';

import SimpleButton from './SimpleButton';
export default function HeroAngledImageOnRight({ blockInfo }) {

    const options = {
        replace: ({ attribs, children }) => {
            if (!attribs) {
                return;
            }
            if (children[0].parent.name === 'a' && attribs?.href) {
                return <a className='text-gray-500' href={attribs?.href} style={{ cursor: "pointer" }} >{domToReact(children, options)}</a>;
            }
        }
    };

    return (
        <div className="relative bg-white">
            <div className="mx-auto" >
                <div className="relative z-10 pb-8 sm:pb-16 md:pb-20 lg:w-full lg:max-w-2xl lg:pb-28 xl:pb-32" style={{ backgroundColor: blockInfo?.backgroundColor }}>
                    <svg
                        className="absolute inset-y-0 right-0 hidden h-full w-48 translate-x-1/2 transform text-white  lg:block"
                        fill={blockInfo?.backgroundColor}
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden="true">
                        <polygon points="50,0 100,0 50,100 0,100" />
                    </svg>
                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="sm:text-center">
                            <div
                                style={{ color: blockInfo?.textColor }}
                                className='preheadline text-xl pt-16 pb-5'>
                                {blockInfo?.preheadline}
                            </div>
                            <h1
                                style={{ color: blockInfo?.textColor }}
                                className="headline text-4xl font-bold tracking-tight  sm:text-5xl md:text-6xl">
                                {blockInfo?.headline}
                            </h1>
                            <div
                                style={{ color: blockInfo?.textColor }}
                                className="subhead mt-3 text-base sm:mx-auto sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0">
                                {parse(blockInfo?.subhead ?? '',)}
                            </div>
                            <div className="mt-5 sm:mt-8 sm:flex sm:justify-center">
                                {blockInfo?.button1 === null ?
                                    <></>
                                    :
                                    <div className="rounded-md">
                                        <SimpleButton blockInfo={blockInfo?.button1} />
                                    </div>
                                }

                                {blockInfo?.button2 === null ?
                                    <></>
                                    :
                                    <div className="mt-3 sm:mt-0 sm:ml-3">
                                        <SimpleButton blockInfo={blockInfo?.button2} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='flex flex-row justify-center items-center w-full'>
                        <div className=" text-md mt-3 text-center  hover:text-gray-500 text-gray-500 visited:text-gray-500  ">
                            {parse(blockInfo?.postButtonText ?? '', options)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="headerImage flex lg:absolute lg:inset-y-0 lg:right-0 lg:w-2/3">
                <img
                    className="h-56 w-full object-cover sm:h-72 md:h-96 lg:h-full lg:w-full"
                    src={blockInfo?.headerImage?.url}
                    alt={blockInfo?.headerImage?.title}
                    loading='lazy'
                />
            </div>
        </div>
    )
}
